// Business configuration constants
export const BUSINESS = {
  name: "Master Mall Nashik",
  tagline: "Complete Electrical Solutions Under One Roof",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_mastermall-showroom/artifacts/g52f9l33_WhatsApp%20Image%202026-07-01%20at%2011.58.29%20PM.jpeg",
  whatsappNumber: "919767233328",
  phoneDisplay: "+91 97672 33328",
  phoneRaw: "+919767233328",
  email: "info@mastermall.online",
  address: {
    line1: "Master Mall,",
    line2: "Behind Sona Shopping Centre,",
    line3: "Ganjmal, Nashik 422001",
  },
  hours: [
    { day: "Monday – Saturday", time: "10:30 AM – 8:00 PM" },
    { day: "Sunday", time: "11:00 AM – 2:00 PM" },
  ],
  socials: {
    facebook: "#",
    instagram: "https://www.instagram.com/master_mall495",
    youtube: "#",
    twitter: "#",
  },
  mapEmbedSrc:
    "https://www.google.com/maps?q=Master+Mall+Ganjmal+Nashik&output=embed",
};

export const waLink = (msg) =>
  `https://wa.me/${BUSINESS.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const defaultWaMessage =
  "Hi Master Mall, I'm interested in your electrical products.";

